import { DeliveryDetails } from './order-input/shared';

export type SearchResult = {
    _id: string;
    type: string;
    patient: PatientInfo;
    created: OrderCreated;
    orderId: string;
    labFlag: boolean;
    deliveryDetails: DeliveryDetails;
    simpleConstructionName: string;
    actionSubCategoryName: string;
    createdDateAndTime: string;
    internalOrderId: string;
};

export type OrderCreated = {
    on: number;
    by: string;
};

export type PatientInfo = {
    firstName: string;
    lastName: string;
    personalIdentityNumber: string;
};

export type Sample = {
    type: string;
};

export enum OrderDirection {
    asc = 'asc',
    desc = 'desc',
}

export type OrderBy = {
    orderBy: string;
    orderDirection: OrderDirection;
};
